import React from "react";

/**
 * Small semantic-token donut chart — filled arc proportional to filled/total.
 */
const MarketplaceDonut = ({ filled = 0, total = 1, size = 16 }) => {
  const safeTotal = Math.max(total, 1);
  const ratio = Math.min(Math.max(filled / safeTotal, 0), 1);
  const stroke = 2.5;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const dash = ratio * c;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className="rc-lcard-adapter__market-donut"
      aria-hidden="true"
    >
      <circle
        className="rc-lcard-adapter__market-donut-track"
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        strokeWidth={stroke}
      />
      <circle
        className="rc-lcard-adapter__market-donut-fill"
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        strokeWidth={stroke}
        strokeDasharray={`${dash} ${c}`}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
    </svg>
  );
};

export const marketplaceIconSrc = (marketplace) => {
  switch (marketplace) {
    case "ebay":
      return "/assets/marketplaces/ebay.png";
    case "chrono24":
      return "/assets/marketplaces/chrono24.webp";
    case "watchfinder":
      return "/assets/marketplaces/watchfinder.jpg";
    default:
      return "/assets/marketplaces/chrono24.webp";
  }
};

export default MarketplaceDonut;
